import type { CompanyRowDto, EmployeeRowDto, ProjectRowDto } from './dto'

type TotalsDto = Pick<ProjectRowDto, 'meeting_count' | 'seconds' | 'private_meeting_count'>

function toTotals(dto: TotalsDto) {
  return {
    meetingCount: dto.meeting_count,
    seconds: dto.seconds,
    privateMeetingCount: dto.private_meeting_count,
  }
}

export function toProjectRow(dto: ProjectRowDto) {
  return {
    ...toTotals(dto),
    projectId: dto.project_id,
    projectName: dto.project_name,
    companyId: dto.company_id,
    companyName: dto.company_name,
  }
}

export function toCompanyRow(dto: CompanyRowDto) {
  return {
    ...toTotals(dto),
    companyId: dto.company_id,
    companyName: dto.company_name,
  }
}

export function toEmployeeRow(dto: EmployeeRowDto) {
  return {
    ...toTotals(dto),
    subject: dto.subject,
    username: dto.username,
    fullName: dto.full_name,
    projects: dto.projects.map(toProjectRow),
    companies: dto.companies.map(toCompanyRow),
  }
}

export function toSlice<Dto, Row>(body: { data: Dto[] }, row: (dto: Dto) => Row) {
  return { rows: body.data.map(row) }
}
